import styles from "../../../../../assets/scss/common/modal/loginModal.module.scss";
import React, {useState} from "react";
import {useModal, useUserAgent} from "../../../../../hooks/hooks";
import {Trans, useTranslation} from "react-i18next";


export function SignupInfoStep4() {
    const { t } = useTranslation("signupModal");
    const {closeModal} = useModal();

    const onClickPurchase = () => {
        closeModal()
        window.location.href = '/purchase-voucher';
        // navigate('/purchase-voucher')
    }

    const onClickInfo = () => {
        closeModal()
        window.location.href = '/mypage';
    }
    const [isInfoHover, setIsInfoHover] = useState(false);
    const [isPurchaseHover, setIsPurchaseHover] = useState(false);
    const {isMobile} = useUserAgent();


    return (
        <>
            <div className={styles.inputArea}>

                <div className={styles.desc}>
                    <Trans t={t} i18nKey={isMobile ? "signup.step4.titleMo" : "signup.step4.title"}
                           components={{accent: <span className={styles.accent}/>, br: <br/>}}
                    />
                </div>
                <div className={styles.maxImg}></div>


                <div className={`${styles.signUpCompleteButtonsWrapper} ${isMobile ? '' : styles.withMarginTop}`}>
                    <button type="button"
                            className={`${styles.signUpNextButton} ${isPurchaseHover ? styles.signUpNextHoverButton : ''}`}
                            onMouseEnter={() => setIsPurchaseHover(true)}
                            onMouseLeave={() => setIsPurchaseHover(false)}
                            onClick={onClickPurchase}
                    >
                        {t("btn.purchaseVoucher")}
                        <div className={`${styles.submitIcon} ${isPurchaseHover ? styles.submitIconHovered : ''}`}/>
                    </button>
                    <button type="button"
                            className={`${styles.signUpNextButton} ${isInfoHover ? styles.signUpNextHoverButton : ''}`}
                            onMouseEnter={() => setIsInfoHover(true)}
                            onMouseLeave={() => setIsInfoHover(false)}
                            onClick={onClickInfo}
                    >
                        {t("btn.myPage")}
                        <div className={`${styles.submitIcon} ${isInfoHover ? styles.submitIconHovered : ''}`}/>
                    </button>
                </div>
            </div>
        </>
    )
}